<template>
<div class="justify-content-between align-items-center content-sidebar px-1">
    <b-form>
      <b-row> 
        <b-col
          cols="12"
          class="title-modal"
        >
          <div class="container-title-text-modal d-flex align-items-center">
            <h5>
              Emprestar Operador
            </h5> 
          </div>
        </b-col>
        <b-col md="12" class="pb-0">
            <b-form-group label="Operador" class="container-operator-select">
                <b-form-input
                    id="operator-select"
                    :value="operator.name"
                    :disabled="true"
                />
            </b-form-group>
            <b-form-group label="Novo Centro de Trabalho">
                <b-form-select
                    id="workcenter-select"
                    v-model="workcenterIDSelected"   
                >
                <b-form-select-option :value="null">Selecione</b-form-select-option>
                <b-form-select-option  
                  v-for="option in workcenters" 
                  :value="option.value" 
                  class="select-option-modal"
                >
                  {{option.label}}
                </b-form-select-option>
                </b-form-select>
            </b-form-group>
            <b-col class="container-btn-borrow d-flex justify-content-end p-0">
                <b-button 
                    class="btn-borrow"  
                    @click="emprestarOperador()"  
                    :disabled="!activeButton"
                >
                    Emprestar
                </b-button>
            </b-col>
        </b-col>
      </b-row>
    </b-form>
  </div>    
</template>

<script>
import {
  BModal, BRow, BFormGroup, BFormInput, BFormSelect, BFormSelectOption, BButton, BCol
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  props:["showToast", "operator", "workcenters", "createAlert"],
  components: {
    BRow,
    VueGoodTable,
    ToastificationContent,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BModal,
    BCol
  },
  data() {
    return{
        workcenterIDSelected: null,
        activeButton: true,
    }
  },
  methods: {
    emprestarOperador() {
      if(this.workcenterIDSelected && this.activeButton){
        this.$http.put(`api/operators/workcenter/${this.operator.id}`,
        {
          "workcenter_id": this.workcenterIDSelected
        }).then(()=>{
          this.showToast('Sucesso', 'SmileIcon', `${this.operator.name} foi emprestado`, 'success')
          this.createAlert(true);
          this.$bvModal.hide('modal-borrow-operator');
        }).catch((error) => {
          this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
        });
      }
      this.activeButton = false;
    }
  },
}
</script>

<style lang="scss">
</style>